import { isoDate } from './time';

export function isDateDisabled(date: Date, today: Date, futureDayCap: number): boolean {
  const cutoff = new Date(today);
  cutoff.setUTCDate(cutoff.getUTCDate() + futureDayCap);

  return isoDate(date) < isoDate(today) || isoDate(date) > isoDate(cutoff);
}
